export const setupPublicLaunchSettings = (root = document) => {
    const settingsForm = root.querySelector?.('form[data-public-launch-settings]');
    if (settingsForm && settingsForm.dataset.publicLaunchSettingsInitialized !== 'true') {
        settingsForm.dataset.publicLaunchSettingsInitialized = 'true';
        const workflowDefinitionVersion = settingsForm.querySelector('#workflowDefinitionVersion');
        const pageId = settingsForm.querySelector('#pageId');
        const pageVersion = settingsForm.querySelector('#pageVersion');
        const selectedPageId = pageId.value;

        if (selectedPageId) {
            $(pageId).dropdown('set selected', selectedPageId, true);
        }
        pageId.addEventListener('change', () => {
            pageVersion.value = '';
        });
        workflowDefinitionVersion.addEventListener('change', () => {
            const selectedVersion = workflowDefinitionVersion.selectedOptions[0];
            const publicLaunchPageId = selectedVersion?.dataset.publicLaunchPageId;
            if (publicLaunchPageId) {
                $(pageId).dropdown('set selected', publicLaunchPageId);
                pageVersion.value = selectedVersion.dataset.publicLaunchPageVersion;
            } else {
                $(pageId).dropdown('clear');
                pageVersion.value = '';
            }
        });
    }

    const componentGuidance = settingsForm?.querySelector('[data-public-launch-component-guidance]');
    if (componentGuidance && componentGuidance.dataset.publicLaunchComponentGuidanceInitialized !== 'true') {
        componentGuidance.dataset.publicLaunchComponentGuidanceInitialized = 'true';
        $(componentGuidance).accordion({
            duration: 0,
            animateChildren: false
        });
    }
};
